// import { canUseDOM } from 'exenv';

export function mic2020YearPageLoading(resp = {}, store = {}) {
  return {
    type: 'MIC_2020_YEAR_PAGE_LOADING',
    micYearPage: resp,
    store
  };
}

export function mic2020YearPageLoaded(resp = {}, store = {}) {
  return {
    type: 'MIC_2020_YEAR_PAGE_LOADED',
    micYearPage: resp,
    store
  };
}

export function mic2020YearPageLoadError(error, store = {}) {
  return {
    type: 'MIC_2020_YEAR_PAGE_ERROR',
    micYearPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
